import { PageControl } from "./page-control";
import { Params } from "@angular/router";

const OBJECT_KEY_NAMES = [
  "evalDealerIds",
  "listView",
  "oemDealerId",
  "oemDealerIds",
  "statuses",
  "searchQuery",
  "segments",
  "destinations",
  "evalTypes",
  "ownerTypes"
];
const NUMBER_KEY_NAMES = ["page"];
const BOOLEAN_KEY_NAMES = ["hasIntegrationError"];
const IGNORED_KEY_NAMES = ["pageControl"];
const PAGE_CONTROL_KEY_NAMES = ["page", "sortField", "sortDirection"];

export class EvaluationHistoryFilter {
  evalDealerIds: string[];
  listView: string;
  oemDealerId: string;
  oemDealerIds: string[];
  pageControl: PageControl;
  searchQuery: string;
  segments: string[];
  statuses: string[];
  destinations: string[];
  evalTypes: string[];
  ownerTypes: string[];
  gridMode?: boolean;

  createdAtIni: Date;
  createdAtEnd: Date;
  makeIds: string[];
  modelIds: string[];
  cityIds: string[];
  ufs: string[];
  scores: number[];
  types: string[];
  regionalIds: string[];
  evaluatorIds: string[];
  sellerIds: string[];
  pricingUserIds: string[];
  sellerManagerUserIds: string[];
  reasonArchives: string[];
  updatedAtIni: string;
  updatedAtEnd: string;
  negotiationStatuses: string[];
  fastQuoteStatuses: string[];
  modelYearStart: number;
  modelYearEnd: number;
  fipeDiffRanges: string[];
  purchasePriceRanges: string[];
  priceType: string;
  hasIntegrationError?: boolean;
  evalDealerDivisions: string[];
  evalDealerMakeIds: string[];
  boughtAtIni: Date;
  boughtAtEnd: Date;
  marginPercentageIni: number;
  marginPercentageEnd: number;
  onlyInInventory: boolean;
  priceComparison: string[];
  onlyTradeIn: boolean;
  noTradeInOnly: boolean;
  pricingEndedAtIni: any;
  pricingEndedAtEnd: any;
  marketModality: string;

  constructor() {
    this.evalDealerIds = [];
    this.listView = "SELLER";
    this.oemDealerId = null;
    this.oemDealerIds = [];
    this.pageControl = {
      page: 0,
      pageSize: 20,
      param: "",
      sortDirection: "DESC",
      sortField: "updatedAt",
      value: {},
    };
    this.searchQuery = "";
    this.segments = null;
    this.statuses = [];
    this.destinations = [];
    this.reasonArchives = [];
  }

  toParamMap(): Params {
    const params: Params = {};
    Object.keys(this).forEach((k) => {
      let value: any;
      if (OBJECT_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.stringify(this[k]);
      } else if (IGNORED_KEY_NAMES.indexOf(k) < 0) {
        value = this[k];
      }
      params[k] = value;
    });

    params.page = this.pageControl.page;
    params.sortField = this.pageControl.sortField;
    params.sortDirection = this.pageControl.sortDirection;
    return params;
  }

  updateFromParamMap(params: Params): void {
    Object.keys(params).forEach((k) => {
      let value: any;
      if (OBJECT_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.parse(params[k]);
      } else if (IGNORED_KEY_NAMES.indexOf(k) < 0) {
        value = params[k];
      }

      if (NUMBER_KEY_NAMES.indexOf(k) >= 0) {
        value = Number(value);
        if (value === Number.NaN) {
          value = undefined;
        }
      } else if (BOOLEAN_KEY_NAMES.indexOf(k) >= 0) {
        value = JSON.parse(value);
      }

      if (value !== undefined) {
        if (PAGE_CONTROL_KEY_NAMES.indexOf(k) >= 0) {
          this.pageControl[k] = value;
        } else {
          this[k] = value;
        }
      }
    });
  }
}

export enum EvaluationHistoryFilterStatusOptions {
  EXPIRED = "Expirado",
  CANCELLED = "Cancelado",
  BOUGHT = "Comprou",
  ARCHIVED = "Arquivado",
}

export enum EvaluationHistoryFilterFilteredStatusOptions {
  EXPIRED = "Expirado",
  CANCELLED = "Cancelado",
  ARCHIVED = "Arquivado",
  SOLD_FAST_QUOTE = "Vendido via cotação rápida"
}

export enum EvaluationHistoryFilterDestinationOptions {
  TRADE_IN = "Repasse",
  SHOWROOM = "Showroom",
}
